import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitcherComponent),
      multi: true,
    }
  ],
  imports: [
    NgClass
  ]
})
export class SwitcherComponent implements ControlValueAccessor {
  @Input() values: unknown[];

  @Output() changeValue = new EventEmitter<any>();

  activeIndex: number = 0;
  isDisabled: boolean = false;

  onSetActive (index: number): void {
    if(this.isDisabled) {return}
    if(index == this.activeIndex) {return}

    this.activeIndex = index;

    this.changeValue.emit(this.values[this.activeIndex]);
    this.onChange(this.values[this.activeIndex]);
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  registerOnChange (fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched (fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState (isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue (obj: any): void {
    if(!obj) {return}
    const valueIndex = this.values.indexOf(obj);
    if(~valueIndex) {
      this.activeIndex = valueIndex;
    }
  }
}
